import React from 'react';
import {Create,TextInput , SimpleForm , SaveButton , Toolbar , BooleanInput, translate,ImageInput,ImageField} from 'react-admin';
import Button from '@material-ui/core/Button';
const MenuSurveyCreateToolbar = translate(({ onCancel, translate, ...props }) => (
    <Toolbar {...props}>
        <SaveButton />
        <Button onClick={onCancel}>{translate('ra.action.cancel')}</Button>
    </Toolbar>
));
const MenuSurveyCreate = ({ onCancel, ...props }) => (
    <Create title="  " {...props}>
        <SimpleForm toolbar ={<MenuSurveyCreateToolbar onCancel={onCancel} />}>
            <BooleanInput source ='published' label="개제 On/Off" />
            <TextInput source="menuName" label="메뉴명" />
            <ImageInput source="menuFile" label="메뉴 섬네일" multiple={false} accept="image/*">
                <ImageField source="src" title="title" />
            </ImageInput>
            <TextInput source ='startDate' label="시작일" />
            <TextInput source ='endDate' label="종료일" />
            <TextInput source ='desc' label="현재상태" disabled/>
        </SimpleForm>
    </Create>
);

export default MenuSurveyCreate;
